// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"92d9e964","484":"8b34722e","551":"9c21a65e","842":"c23e5f16","851":"d9349099"}[chunkId] + ".chunk.js";
};